export const getSavedForms = () => {
    const savedForms = localStorage.getItem('saved_forms');
    const parsedForms = savedForms ? JSON.parse(savedForms) : {};
    return parsedForms;
}

export const getSavedForm = (formID: string) => {
    const savedForms = getSavedForms();
    return savedForms[formID] ?? null;
}

export const saveForm = (formID: string, formData: any) => {
    const savedForms = getSavedForms()
    savedForms[formID] = formData;
    localStorage.setItem('saved_forms', JSON.stringify(savedForms));
}

export const clearLocalStorage = () => {
    localStorage.removeItem('saved_forms');
}

export const removeSavedForm = (formID: string) => {
    const savedForms = getSavedForms();
    delete savedForms[formID];
    localStorage.setItem('saved_forms', JSON.stringify(savedForms));
}

export const getLocalStorageItem = (key: string) => {
    const localStorageItem = localStorage.getItem(key);
    const parsedItem = localStorageItem ? JSON.parse(localStorageItem) : {};
    return parsedItem;
}

export const setLocalStorageItem = (key: string, data: Record<string, any>) => {
    localStorage.setItem(key, JSON.stringify(data));
    return true;
}